"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostValuatorModelsSaleValuationPostSecurity$ = exports.PostValuatorModelsSaleValuationPostSecurity$outboundSchema = exports.PostValuatorModelsSaleValuationPostSecurity$inboundSchema = void 0;
exports.postValuatorModelsSaleValuationPostSecurityToJSON = postValuatorModelsSaleValuationPostSecurityToJSON;
exports.postValuatorModelsSaleValuationPostSecurityFromJSON = postValuatorModelsSaleValuationPostSecurityFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.PostValuatorModelsSaleValuationPostSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.PostValuatorModelsSaleValuationPostSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostValuatorModelsSaleValuationPostSecurity$;
(function (PostValuatorModelsSaleValuationPostSecurity$) {
    /** @deprecated use `PostValuatorModelsSaleValuationPostSecurity$inboundSchema` instead. */
    PostValuatorModelsSaleValuationPostSecurity$.inboundSchema = exports.PostValuatorModelsSaleValuationPostSecurity$inboundSchema;
    /** @deprecated use `PostValuatorModelsSaleValuationPostSecurity$outboundSchema` instead. */
    PostValuatorModelsSaleValuationPostSecurity$.outboundSchema = exports.PostValuatorModelsSaleValuationPostSecurity$outboundSchema;
})(PostValuatorModelsSaleValuationPostSecurity$ || (exports.PostValuatorModelsSaleValuationPostSecurity$ = PostValuatorModelsSaleValuationPostSecurity$ = {}));
function postValuatorModelsSaleValuationPostSecurityToJSON(postValuatorModelsSaleValuationPostSecurity) {
    return JSON.stringify(exports.PostValuatorModelsSaleValuationPostSecurity$outboundSchema.parse(postValuatorModelsSaleValuationPostSecurity));
}
function postValuatorModelsSaleValuationPostSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostValuatorModelsSaleValuationPostSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PostValuatorModelsSaleValuationPostSecurity' from JSON`);
}
//# sourceMappingURL=postvaluatormodelssalevaluationpost.js.map